import { render } from "./ComponentListSubcategories.vue?vue&type=template&id=6a30e6dd&scoped=true"
import script from "./ComponentListSubcategories.vue?vue&type=script&lang=js"
export * from "./ComponentListSubcategories.vue?vue&type=script&lang=js"

import "./ComponentListSubcategories.vue?vue&type=style&index=0&id=6a30e6dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a30e6dd"]])

export default __exports__